import { EventBus } from "../../../eventbus";

export default {
  data() {
    return {
      typeOptions: [
        {
          name: "file",
          icon: "file--simple",
        },
        {
          name: "folder",
          icon: "file--simple",
        },
      ],
      typesSelected: [],
      extensionsSelected: [],
      extensions: [],
    };
  },
  created() {
    EventBus.$on(``);
  },
  methods: {
    toggleExtensions(event) {
      if ($(this.$refs.extensionoptions).hasClass("active")) {
        $(event.target).removeClass("active");
        $(this.$refs.extensionoptions).removeClass("active");
      } else {
        $(event.target).addClass("active");
        $(this.$refs.extensionoptions).addClass("active");
      }
    },
    toggleTypes(event) {
      if ($(this.$refs.typesoptions).hasClass("active")) {
        $(event.target).removeClass("active");
        $(this.$refs.typesoptions).removeClass("active");
      } else {
        $(event.target).addClass("active");
        $(this.$refs.typesoptions).addClass("active");
      }
    },
  },
  watch: {
    typesSelected() {
      EventBus.$emit("filterByExtensionAndType", {
        extensions: this.extensionsSelected,
        types: this.typesSelected,
      });
    },
    extensionsSelected() {
      EventBus.$emit("filterByExtensionAndType", {
        extensions: this.extensionsSelected,
        types: this.typesSelected,
      });
    },
  },
};
